import { UseMutationOptions } from 'react-query';
import apiClient, { apiRequest, switchBaseUrl } from '../apiCall'
import { LoginPayload, RegisterPayload, ResetPasswordPayload } from '../types/Auth/authApiRequestType';
import { ILoginResponse } from '../interfaces/auth';


/**
 * Post Login
 * @returns
 */
const postLogin = async (params: LoginPayload): Promise<ILoginResponse> => {
    // switchBaseUrl(apiClient, true)
    try {
        const response = await apiRequest("Token.Token", params, "", true);
        return response.data
    } catch (error: any) {
        throw error
    }


}

const postRegister = async (params: RegisterPayload): Promise<any> => {
    // switchBaseUrl(apiClient, true)
    try {
        const response = await apiRequest('Register.RegisterUser', params);
        return response.data
    } catch (error: any) {
        throw new Error(error)
    }
}


const postResetPassword = async (params: ResetPasswordPayload): Promise<any> => {
    switchBaseUrl(apiClient, false)
    try {
        const response = await apiRequest('UserManagement.SendResetPasswordEmail', params);
        return response.data
    } catch (error: any) {
        throw new Error(error)
    }
}


export { postLogin, postRegister, postResetPassword }